import React from "react";

function GarrariBikes() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Garrari Bikes
        </h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>Garrari Bikes</strong> is where passion meets precision in the
          world of cycling. Renowned for top-quality bikes and exceptional
          service, we strive to provide cyclists with the ultimate riding
          experience.
        </p>
      </div>

      {/* Key Highlights */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Why Choose Garrari Bikes?
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          <li>
            <strong className="text-gray-900">Uncompromising Quality:</strong>{" "}
            From cutting-edge designs to meticulous craftsmanship, our bikes are
            engineered for performance and durability.
          </li>
          <li>
            <strong className="text-gray-900">Diverse Range of Models:</strong>{" "}
            Whether you're a road cyclist, mountain biking enthusiast, daily
            commuter, or eco-conscious rider, we have the perfect bike for you.
          </li>
          <li>
            <strong className="text-gray-900">Innovative Technology:</strong>{" "}
            Features like smart connectivity, electric-assist options, and
            advanced engineering make your ride exceptional.
          </li>
          <li>
            <strong className="text-gray-900">
              Personalized Customer Service:
            </strong>{" "}
            Our knowledgeable team helps you choose the ideal bike for your
            needs and preferences.
          </li>
          <li>
            <strong className="text-gray-900">
              Easy Online Shopping Experience:
            </strong>{" "}
            Hassle-free browsing and secure transactions with efficient
            delivery.
          </li>
          <li>
            <strong className="text-gray-900">
              Sustainable and Eco-Friendly Practices:
            </strong>{" "}
            We contribute to a greener planet with eco-friendly models and
            packaging options.
          </li>
          <li>
            <strong className="text-gray-900">Community and Events:</strong>{" "}
            Join a vibrant community of cyclists and participate in exciting
            events.
          </li>
          <li>
            <strong className="text-gray-900">
              Warranty and After-Sales Support:
            </strong>{" "}
            Enjoy peace of mind with our warranty and dedicated support team.
          </li>
          <li>
            <strong className="text-gray-900">Reviews and Testimonials:</strong>{" "}
            Explore positive feedback from satisfied customers who love Garrari
            Bikes.
          </li>
          <li>
            <strong className="text-gray-900">
              Embrace the Garrari Lifestyle:
            </strong>{" "}
            Celebrate the joy of cycling, adventure, and freedom with Garrari
            Bikes.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default GarrariBikes;
